import { CertificationsTable } from "@/components/certifications/CertificationsTable";
import { useSetBreadcrumbs } from "@/components/shared/breadcrumbs";
import { PageHeader } from "@/components/shared/page-header";

export function CertificationsPage() {
  useSetBreadcrumbs([{ label: "Capability" }, { label: "Certifications" }]);

  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow="Capability"
        title="Certifications"
        description="Master catalog of certifications that people can be assigned and tracked against."
      />
      <CertificationsTable />
    </div>
  );
}
